import AsyncStorage from '@react-native-async-storage/async-storage';

/** Both keys are kept in sync so Profile/Offline settings and Documents use one preference. */
const AUTO_DOWNLOAD_KEYS = ['@tripvio_auto_download_enabled', '@tripflow_auto_download_enabled'] as const;

/**
 * Auto-download is on unless the user has turned it off in any stored slot.
 * Default: enabled (same as previous `value !== 'false'` behavior).
 */
export async function getAutoDownloadDocumentsEnabled(): Promise<boolean> {
  try {
    const values = await Promise.all(AUTO_DOWNLOAD_KEYS.map((k) => AsyncStorage.getItem(k)));
    if (values.some((v) => v === 'false')) return false;
    return true;
  } catch {
    return true;
  }
}

/** Persist to every legacy/new key so all screens agree. */
export async function setAutoDownloadDocumentsEnabled(enabled: boolean): Promise<void> {
  const s = enabled ? 'true' : 'false';
  await Promise.all(AUTO_DOWNLOAD_KEYS.map((k) => AsyncStorage.setItem(k, s)));
}
